import type {
  AssignCoachRequest,
  CoachAssignmentHistory,
  CoachAssignmentResult,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1218 (Ö-407) — the patient's primary coach.

const base = (patientId: string) =>
  `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/coach`;

function headers(): Record<string, string> {
  return { "Content-Type": "application/json", ...tenantHeader() };
}

export async function fetchCoachAssignments(
  patientId: string,
): Promise<CoachAssignmentHistory> {
  const res = await apiFetch(`${base(patientId)}/assignments`, {
    headers: headers(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

/** "Tilldela mig" — the signed-in coach takes the patient. */
export async function claimCoach(
  patientId: string,
): Promise<CoachAssignmentResult> {
  const res = await apiFetch(`${base(patientId)}/claim`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({}),
    ...withCredentials,
  });
  return jsonOr401(res);
}

/** "Tilldela coach" — an admin assigns or reassigns. */
export async function assignCoach(
  patientId: string,
  body: AssignCoachRequest,
): Promise<CoachAssignmentResult> {
  const res = await apiFetch(`${base(patientId)}/assign`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(body),
    ...withCredentials,
  });
  return jsonOr401(res);
}
